module.exports = __webpack_public_path__ + "img/t1-media-block.b9e3ac53.png";